import { database as db, authentication as auth } from '../app-database';

export const guardarDatosAsistido = (sPaterno, sMaterno, sNombres) => {
    db.ref("registro/" + auth.currentUser.uid).once("value").then(oValue => {
        db.ref("registro/" + auth.currentUser.uid).set({...oValue.val(),
    		"apaterno": sPaterno,
    		"amaterno": sMaterno,
    		"nombres": sNombres
        });
    });
    
    return {
        "type": "REGISTRO_ASISTIDO_COMPLETAR",
        "apaterno": sPaterno,
        "amaterno": sMaterno,
        "nombres": sNombres
    };
};

export const guardarDatosInconvenientes = (sTipo, sExtension, sLada, sTelefono) => {
    db.ref("registro/" + auth.currentUser.uid).once("value").then(oValue => {
        db.ref("registro/" + auth.currentUser.uid).set({...oValue.val(),
    		"tipoTelefono": sTipo,
    		"extension": sExtension,
    		"lada": sLada,
    		"telefono": sTelefono
        });
    });
    
    return {
		"type": "REGISTRO_ASISTIDO_INCONVENIENTES",
		"tipo": sTipo,
        "extension": sExtension,
        "lada": sLada,
        "telefono": sTelefono
	};
};


// WEBPACK FOOTER //
// ./src/registro-asistido/service.act.js